/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type MoveBookingInput = {
    bookingId: string;
    destinationVehicleId?: string | null | undefined;
    sourceVehicleId?: string | null | undefined;
};
export type MoveBookingMutationVariables = {
    input: MoveBookingInput;
};
export type MoveBookingMutationResponse = {
    readonly moveBooking: {
        readonly bookingId: string;
        readonly vehicle: {
            readonly vehicleId: string;
        } | null;
    };
};
export type MoveBookingMutation = {
    readonly response: MoveBookingMutationResponse;
    readonly variables: MoveBookingMutationVariables;
};



/*
mutation MoveBookingMutation(
  $input: MoveBookingInput!
) {
  moveBooking(input: $input) {
    bookingId
    vehicle {
      vehicleId
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Booking",
    "kind": "LinkedField",
    "name": "moveBooking",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vehicle",
        "kind": "LinkedField",
        "name": "vehicle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MoveBookingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveBookingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "23c4f60e15aadfa92eb8d379e1c1ce25",
    "id": null,
    "metadata": {},
    "name": "MoveBookingMutation",
    "operationKind": "mutation",
    "text": "mutation MoveBookingMutation(\n  $input: MoveBookingInput!\n) {\n  moveBooking(input: $input) {\n    bookingId\n    vehicle {\n      vehicleId\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'efb66e0d6e5229cba0874e8c75dde9c8';
export default node;
